import { preferenceEditors } from '../preference-editors/preferenceEditors';
import type { UserPreferenceKey } from '../types';

export function getVisiblePreferenceKeys(
  preferenceVisibility?: (key: UserPreferenceKey) => boolean
): UserPreferenceKey[] {
  return getVisiblePreferenceEditors(preferenceVisibility).map(
    (e) => e.meta.id as UserPreferenceKey
  );
}

export function getVisiblePreferenceEditors(
  preferenceVisibility?: (key: UserPreferenceKey) => boolean
) {
  return preferenceEditors.filter(({ meta }) => {
    const prefKey = meta.id as UserPreferenceKey;
    return preferenceVisibility ? preferenceVisibility(prefKey) : true;
  });
}
